import { render, staticRenderFns } from "./guideIndex.vue?vue&type=template&id=06b6dad4&"
import script from "./guideIndex.vue?vue&type=script&lang=js&"
export * from "./guideIndex.vue?vue&type=script&lang=js&"
import style0 from "./guideIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports